export const RECAPTCHA_SCRIPT_ID = 'google-recaptcha-v3';